import React from 'react';
import { motion } from 'framer-motion';
import ScrollAnimation from './ScrollAnimation';
import FeatureGrid from './features/FeatureGrid';

export default function Features() {
  return (
    <ScrollAnimation threshold={0} rootMargin="0px">
      <section id="features" className="py-32 bg-dark">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16 stagger-item">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="inline-block relative mb-4"
            >
              <div className="bg-gradient-to-r from-primary/10 via-secondary/10 to-primary/10 text-primary px-6 py-2 rounded-full text-sm font-semibold backdrop-blur-sm border border-primary/10">
                Transformative Features
              </div>
              <div className="absolute inset-0 bg-gradient-to-r from-primary/20 via-secondary/20 to-primary/20 blur-xl opacity-50 -z-10" />
            </motion.div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              The Benefits Of Our Method Will <span className="text-primary">Propel You Forward</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Click each card to discover the transformative feature behind each outcome
            </p>
          </div>
          <FeatureGrid />
        </div>
      </section>
    </ScrollAnimation>
  );
}